const productionConfig = {
  segment: {
    enabled: false,
    publicKey: '6NftxrUb0QfhkIaOqcpbfxjZDhvNEExm'
  },
  sentry: {
    projectId: 237613,
    publicKey: '014f9707c27b4e7ea90aff051a82e561',
    dsn: 'https://014f9707c27b4e7ea90aff051a82e561@o104929.ingest.sentry.io/237613'
  },
  vwo: {
    enabled: true
  },
  rudderstack: {
    enabled: true,
    publicKey: '2A5AmcNdnGyb5kBeZJrij0iIPwI'
  }
};

module.exports = productionConfig;
